/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from "react";
import { useDocument, useDocumentReadOnly } from "../hook/useDocument";
import { LoaderCircle, Pencil, X } from "lucide-react";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Button } from "@/components/ui/button";
import { ItemMasterMapping } from "./item-master-mapping";
// import { IsSimilarityMatch } from "./is-similarity-match";

export const ItemMasterSelect = ({
  data,
  parentKey,
  endPoint,
  setEditActive,
  keyValue,
  // is_similarity_match,
}: any) => {
  const [
    state,
    _setState,
    _searchAddress,
    _updateAddress,
    _searchSupplier,
    _updateSupplierMapping,
    searchItemMaster,
    updateItemMaster,
  ] = useDocument();
  const [edit, setEdit] = useState(false);
  const [isPending, startTransition] = useState(false);
  // Void and deleted documents are read-only
  const isVoid = useDocumentReadOnly();
  const updateSupplierMappingData = async (prop: any) => {
    console.log({ key: parentKey, payload: prop });
    startTransition(true);
    await updateItemMaster({ key: parentKey, payload: prop });
    startTransition(false);
  };

  return (
    <ConditionRenderer condition={edit}>
      <div className="flex justify-between items-center w-full">
        <ItemMasterMapping
          placeholder={`Search ${keyValue?.replaceAll("_", " ")}`}
          isPending={isPending}
          onChange={(prop: string) => {
            setEdit(false);
            updateSupplierMappingData(prop);
            // updateSupplierMapping({ key: parentKey, payload: prop });
          }}
          onSearch={(prop) =>
            searchItemMaster({
              value: prop,
              endPoint: endPoint.value.replace("api", ""),
            })
          }
          value={""}
          onBlur={() => {}}
        />
        <Button
          size={"icon"}
          className="text-red-500"
          variant={"ghost"}
          onClick={() => setEdit(false)}
        >
          <X />
        </Button>
      </div>
      <div className="flex justify-between items-center w-full">
        <span
          className="flex  gap-1 py-2 flex-1"
          onClick={() => !isVoid && setEditActive(true)}
        >
          {data}
        </span>
        <Button
          size={"icon"}
          className="text-primary"
          variant={"ghost"}
          disabled={isVoid}
          onClick={() => {
            setEdit(true);
          }}
        >
          <Pencil />
        </Button>

        {isPending ? (
          <span className="absolute left-0 top-0 w-full  h-full bg-white/40 flex items-center justify-center">
            <LoaderCircle className="animate-spin" />
          </span>
        ) : null}
      </div>
    </ConditionRenderer>
  );
};
